"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateMomentWithEditorTags = updateMomentWithEditorTags;

var _ = require("..");

var _tagData = require("./tagData");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Will return a new object updated with edits from the editor tags
 *
 * @export
 * @param {Object} moment - a moment object
 * @param {[]} editorTags - array of editor tags
 * @param {boolean} requireSelected - will only apply updates from selected tags when true, default is true
 */
function updateMomentWithEditorTags(moment, editorTags) {
  // deep clone the moment
  var next = JSON.parse(JSON.stringify(moment));
  next.meta.type = "";
  next.meta.trace_numbers = []; // update attributes from editor tags

  var _iterator = _createForOfIteratorHelper(editorTags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;
      var editorAttr = (0, _.getProperty)("editor.attributes", tag, null);

      if (tag.selected === true && editorAttr) {
        deepUpdate(editorAttr, next, deepUpdateApplyTagAttributes);
      }
    } // prep update tags

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var sport = (0, _.getProperty)("sport_type", next, "soccer");
  var tagMap = sport === "soccer" ? _tagData.SOCCER_TAGS : _tagData.BASEBALL_TAGS;
  var nextTags = []; // preserve read only tags

  var _iterator2 = _createForOfIteratorHelper(next.tags),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _tag = _step2.value;
      var tm = tagMap[_tag.name];

      if (tm && tm.read_only === true) {
        var repTags = (0, _.getProperty)("editor.represents", tm, null);

        if (!repTags) {
          repTags = [_tag.name];
        }

        var _iterator4 = _createForOfIteratorHelper(repTags),
            _step4;

        try {
          var _loop = function _loop() {
            var rp = _step4.value;
            var index = nextTags.findIndex(function (t) {
              return t.name === rp;
            });

            if (index === -1) {
              nextTags.push({
                name: rp,
                category: _tag.category
              });
            }
          };

          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        var attr = (0, _.getProperty)("editor.attributes", tm, null);

        if (attr) {
          deepUpdate(attr, next, deepUpdateApplyTagAttributes);
        }
      }
    } // add selected tags

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(editorTags),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var editorTag = _step3.value;

      if (editorTag.selected === true) {
        var _repTags = (0, _.getProperty)("editor.represents", editorTag, null);

        if (!_repTags) {
          _repTags = [editorTag.name];
        }

        var _iterator5 = _createForOfIteratorHelper(_repTags),
            _step5;

        try {
          var _loop2 = function _loop2() {
            var rp = _step5.value;
            var index = nextTags.findIndex(function (t) {
              return t.name === rp;
            });

            if (index === -1) {
              nextTags.push({
                name: rp,
                category: editorTag.category
              });
            }
          };

          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    } // apply tag update

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  next.tags = nextTags;
  return next;
}

function deepUpdateApplyTagAttributes(key, value, target) {
  switch (key) {
    case "type":
      var types = target[key].split(" ");
      var values = value.split(" ");
      types = types.concat(values);
      target[key] = types.join(" ").trim();
      break;

    case "trace_numbers":
      var nums = target[key];

      if (!nums) {
        nums = [];
      }

      nums.push(value);
      target[key] = nums;
      break;

    default:
      target[key] = value;
      break;
  }
}

function deepUpdate(update, target) {
  var apply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var updateKeys = Object.keys(update);

  for (var _i = 0, _updateKeys = updateKeys; _i < _updateKeys.length; _i++) {
    var key = _updateKeys[_i];
    var value = update[key];

    if (_typeof(value) === "object") {
      if (value === null) {
        target[key] = null;
      } else {
        if (!target[key]) {
          target[key] = {};
        }

        deepUpdate(value, target[key], apply);
      }
    } else {
      if (apply) {
        apply(key, value, target);
      } else {
        target[key] = value;
      }
    }
  }
}